export default "__VITE_ASSET__DM6$TMFz__"